document.addEventListener('DOMContentLoaded', () => {
    setTimeout(renderSubscriptionOption, 1_000);
});


document.addEventListener("variant:update", onVariantUpdated);


function renderSubscriptionOption() {
    const freq = document.querySelector('og-offer div:has(og-select-frequency)');

    const sub = document.querySelector('og-offer div:has(og-optin-button ~ og-price)');

    if (!freq || !sub) return;

    sub.appendChild(freq);

    const newDiv = document.createElement('div');
    newDiv.classList.add('sub-price');

    const subCard = document.querySelector('og-offer div:has(og-optin-button~og-price)');

    if (!subCard) return

    const subCardLabels = subCard.querySelectorAll('og-optin-button, og-price');
    subCardLabels.forEach((element) => newDiv.appendChild(element));

    subCard.prepend(newDiv);

    renderRenewalNote(subCard);

    hideDecorativeOgIcons();

    document.querySelector('og-offer')?.classList.add('visible');
}

// Auto-renewal disclosure shown inside the subscription card. The frequency
// follows whatever the customer picks in the Ordergroove "Deliver Every" select.
const RENEWAL_TERMS_URL = '/policies/terms-of-service#subscriptions';

function selectedFrequencyLabel() {
    const select = document
        .querySelector('og-offer og-select-frequency')
        ?.shadowRoot?.querySelector('og-select')
        ?.shadowRoot?.querySelector('select');
    const option = select?.options[select.selectedIndex];
    return option ? option.text.replace(/\(.*?\)/g, '').trim() : '';
}

function updateRenewalNote() {
    const freq = document.querySelector('.og-renewal-note__freq');
    if (!freq) return;
    const label = selectedFrequencyLabel();
    freq.textContent = label ? `every ${label}` : 'on the schedule you choose';
}

function renderRenewalNote(subCard) {
    if (!subCard || subCard.querySelector('.og-renewal-note')) return;

    const note = document.createElement('p');
    note.className = 'og-renewal-note';
    note.innerHTML =
        'Your subscription renews automatically <span class="og-renewal-note__freq">on the schedule you choose</span> ' +
        'and your card is charged the subscription price for each delivery until you cancel. ' +
        'Cancel anytime online under <strong>Account &rsaquo; Manage Subscriptions</strong>, ' +
        'or call 1-866-462-8736. ' +
        `<a href="${RENEWAL_TERMS_URL}">Subscription &amp; cancellation terms</a>`;
    subCard.appendChild(note);

    updateRenewalNote();

    const offer = document.querySelector('og-offer');
    if (offer && !offer.dataset.renewalObserved) {
        offer.dataset.renewalObserved = 'true';
        new MutationObserver(updateRenewalNote).observe(offer, {
            attributes: true,
            attributeFilter: ['frequency', 'subscribed'],
            subtree: true,
        });
        offer.addEventListener('change', () => setTimeout(updateRenewalNote, 50), true);
        offer.addEventListener('click', () => setTimeout(updateRenewalNote, 50), true);
    }
}

function onVariantUpdated(event) {
    const newHTML = event.detail.data.html;

    const updateElement = (/** @type {string} */ elementQuery) => {
        const newElement = newHTML.querySelector(elementQuery);
        const currentElement = document.querySelector(elementQuery);

        if (!newElement || !currentElement) return;

        if (newElement.innerHTML !== currentElement.innerHTML) {
            currentElement.replaceWith(newElement);
        }
    }

    updateElement("og-offer");
    renderSubscriptionOption();
}


// The Ordergroove widget renders small decorative icons with no accessible name.
// They sit next to visible text, so hide them from screen readers rather than
// having them announced as an unnamed graphic.
function hideDecorativeOgIcons() {
    const roots = [document];
    document.querySelectorAll('og-offer, og-offer *').forEach((el) => {
        if (el.shadowRoot) roots.push(el.shadowRoot);
    });
    roots.forEach((root) => {
        root.querySelectorAll('og-offer svg, og-offer-incentive svg, svg').forEach((svg) => {
            if (root === document && !svg.closest('og-offer')) return;
            if (svg.hasAttribute('aria-hidden')) return;
            if (svg.closest('a, button') && !svg.closest('a, button').getAttribute('aria-label')) return;
            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
        });
    });
}
